import React, {useState} from 'react';
import {Button, FormGroup, Panel} from 'react-bootstrap';
import {Cross} from '../misc/Cross';

export const BOOLEAN_TYPE = 'BOOLEAN_TYPE';

export const createBooleanFilter = (fieldName) => {
  if (!fieldName || fieldName === '') {
    throw new Error('a new filter must have a field name.');
  }

  return {
    type: BOOLEAN_TYPE,
    fieldName
  };
};

export const renderBooleanFilter = (key = '', filterOptions = {}, removeCallback, editCallback) => {
  const {type, id, fieldName, displayName, status} = filterOptions;
  if (type !== BOOLEAN_TYPE) {
    return (
      <p style="color: red">ERROR: Text filter rendered with wrong type</p>
    );
  }

  return <BooleanFilter
    key={key}
    type={type}
    name={fieldName}
    id={id}
    status={status}
    displayName={displayName}
    removeCallback={removeCallback}
    editCallback={editCallback}
  />;
};

export const createContentfulBooleanFilterString = ({fieldName, status}) => {
  // Return the filter as a tuple with the first item is the key and second is value.
  return [`${fieldName}`, status];
};

export const BooleanFilter = ({type, name, id, status, displayName, removeCallback, editCallback}) => {
  const [showEditDialogue, setShowEditDialogue] = useState(false);

  if (type !== BOOLEAN_TYPE) {
    return (
      <p style="color: red">ERROR: Boolean filter rendered with wrong type</p>
    );
  }

  const editFilterCallback = (id, fieldName, type, options) => {
    editCallback(id, fieldName, type, options);
    setShowEditDialogue(false);
  };

  const filterOptions = {
    type: type,
    id: id,
    fieldName: name
  };

  return (
    <div>

      <div className='filter-item' onClick={() => setShowEditDialogue(true)}>
        <span className='filter-item-inner'>
          <b>{displayName}</b> <i>er</i> {status === true ? 'satt' : 'ikke satt'}
        </span>
        <a href="#" role="button" style={{padding: '0 5px'}} onClick={(e) => {
          e.preventDefault();
          removeCallback(id);
        }}>
          <Cross />
        </a>
      </div>
      <div id="edit-filter-backdrop" className={showEditDialogue ? 'invisible-backdrop' : ''} onClick={() => setShowEditDialogue(false)} />
      <Panel id="edit-filter" expanded={showEditDialogue} defaultExpanded={false} style={{
        position: 'absolute'
      }}>
        <Panel.Collapse>
          <Panel.Body style={{padding: 8}}>
            <div className='filter-panel-body'>
              <div>
                <label style={{display: 'flex', justifyContent: 'space-between'}}>
                  <b>Endre filter</b>
                  <a href="#" role="button" style={{padding: '0 5px'}} onClick={(e) => {
                    e.preventDefault();
                    setShowEditDialogue(false);
                  }}>
                    <Cross />
                  </a>
                </label>
              </div>
              <BooleanFilterEditDialogue displayName={displayName} existingStatus={status} editFilterCallback={editFilterCallback} filterOptions={filterOptions} />
            </div>
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    </div>
  );
};

export const BooleanFilterAddDialogue = ({displayName, filterCallback, filterOptions = {}}) => {
  const [status, setStatus] = useState(true);
  const {type, fieldName} = filterOptions;

  if (type !== BOOLEAN_TYPE) {
    return (
      <p style="color: red">ERROR: Boolean filter rendered with wrong type</p>
    );
  }

  const onStatusChange = (e) => {
    setStatus(e.target.value === true);
  };

  const addFilter = () => {
    filterCallback(fieldName, BOOLEAN_TYPE, {
      displayName: displayName,
      status
    });
  };

  return (
    <>
      <FormGroup>
        <select className="form-control" onChange={onStatusChange}>
          <option value="true">Ja</option>
          <option value="false">Nei</option>
        </select>
      </FormGroup>
      <Button bsStyle="primary" onClick={addFilter}>
        Legg til filter
      </Button>
    </>
  );
};

export const BooleanFilterEditDialogue = ({displayName, existingStatus, editFilterCallback, filterOptions = {}}) => {
  const [status, setStatus] = useState(existingStatus);
  const {fieldName, id} = filterOptions;

  const onStatusChange = (e) => {
    setStatus(e.target.value === 'true');
  };

  const editFilter = () => {
    editFilterCallback(id, fieldName, BOOLEAN_TYPE, {
      displayName: displayName,
      status
    });
  };

  return (
    <>
      <FormGroup>
        <select className="form-control" defaultValue={status} onChange={onStatusChange}>
          <option value="true">Ja</option>
          <option value="false">Nei</option>
        </select>
      </FormGroup>
      <Button bsStyle="primary" onClick={editFilter} disabled={status === ''}>
        Oppdater filter
      </Button>
    </>
  );
};
